import React from "react";
import { PageHero, Reveal } from "../components/Shared";
import { company } from "../mock";
import useSEO from "../hooks/useSEO";

const kvkkContent = {
  title: "KVKK Bilgilendirmesi",
  subtitle:
    "6698 Sayılı Kişisel Verilerin Korunması Kanunu kapsamında aydınlatma metni.",
  sections: [
    {
      heading: "Veri Sorumlusu",
      text: `${company.fullName} ("Nikomedya Turizm") olarak, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca veri sorumlusu sıfatıyla, kişisel verilerinizin güvenliğine ve gizliliğine önem veriyoruz.`,
    },
    {
      heading: "İşlenen Kişisel Veriler ve İşleme Amaçları",
      text: "Web sitemiz ve iletişim kanallarımız aracılığıyla paylaştığınız ad-soyad, telefon numarası, e-posta adresi gibi kişisel veriler; taleplerinizin karşılanması, hizmetlerimiz hakkında bilgilendirme yapılması, teklif süreçlerinin yürütülmesi ve yasal yükümlülüklerin yerine getirilmesi amaçlarıyla işlenmektedir.",
    },
    {
      heading: "Kişisel Verilerin Aktarılması",
      text: "Kişisel verileriniz, yasal zorunluluklar ve hizmet gereklilikleri dışında üçüncü kişilerle paylaşılmaz. Yalnızca ilgili mevzuat kapsamında yetkili kamu kurum ve kuruluşlarına aktarılabilir.",
    },
    {
      heading: "Haklarınız",
      text: "KVKK'nın 11. maddesi uyarınca; kişisel verilerinizin işlenip işlenmediğini öğrenme, işlenmişse buna ilişkin bilgi talep etme, işlenme amacını öğrenme, eksik veya yanlış işlenmişse düzeltilmesini isteme, silinmesini veya yok edilmesini talep etme haklarına sahipsiniz. Talepleriniz için bize " + company.email + " adresinden ulaşabilirsiniz.",
    },
  ],
};

const cerezContent = {
  title: "Çerez Politikası",
  subtitle:
    "Web sitemizde kullanılan çerezler hakkında bilgilendirme.",
  sections: [
    {
      heading: "Çerez Nedir?",
      text: "Çerezler (cookies), ziyaret ettiğiniz web siteleri tarafından tarayıcınıza kaydedilen küçük metin dosyalarıdır. Çerezler, web sitesinin daha verimli çalışmasını sağlamak ve kullanıcı deneyimini iyileştirmek amacıyla kullanılır.",
    },
    {
      heading: "Hangi Çerezleri Kullanıyoruz?",
      text: "Web sitemizde; sitenin temel işlevlerini yerine getirmesini sağlayan zorunlu çerezler ve site kullanımını analiz etmemize yardımcı olan performans çerezleri kullanılmaktadır. Bu çerezler kişisel kimlik tespitine imkan verecek veri toplamaz.",
    },
    {
      heading: "Çerezleri Nasıl Kontrol Edebilirsiniz?",
      text: "Tarayıcınızın ayarlarından çerezleri kabul etme veya reddetme seçeneklerini yönetebilirsiniz. Çerezleri devre dışı bırakmanız durumunda web sitemizin bazı özellikleri beklendiği gibi çalışmayabilir.",
    },
    {
      heading: "İletişim",
      text: "Çerez politikamız hakkında sorularınız için " + company.email + " adresinden bizimle iletişime geçebilirsiniz.",
    },
  ],
};

const LegalPage = ({ type }) => {
  const content = type === "kvkk" ? kvkkContent : cerezContent;

  useSEO({
    title: content.title,
    description: content.subtitle,
  });

  return (
    <div>
      <PageHero title={content.title} subtitle={content.subtitle} />
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <div className="space-y-10">
              {content.sections.map((s) => (
                <div key={s.heading}>
                  <h2 className="text-xl font-bold text-[#0d2b4f] mb-3">
                    {s.heading}
                  </h2>
                  <p className="text-[#3a4a5d] leading-[1.9] text-[15px]">
                    {s.text}
                  </p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default LegalPage;
